import { Box } from '@alf/uikit';
import StatusLabel from '../../../StatusLabel';
import BonusImage from '../BonusImage';
import BonusInfo from '../BonusInfo';

import styles from '../../index.module.css';

const CardContent = ({
  bonus,
  status,
  imageUrl = '',
  name = '',
  detailsList,
  id,
  classNames,
  isBonusDetailsLinkVisible,
  isBsBonus,
  cardType
}) => {
  return (
    <Box
      align="start"
      className={`${styles[`card_${status}`] || ''} ${styles.content}`}
    >
      <StatusLabel
        status={status}
        className={styles.status}
        classNames={classNames}
      />
      <BonusImage bonus={bonus} oldImageUrl={imageUrl} />
      <BonusInfo
        name={name}
        id={id}
        className={`${styles[`card_${status}`] || ''}`}
        status={status}
        detailsList={detailsList}
        isBonusDetailsLinkVisible={isBonusDetailsLinkVisible}
        isBsBonus={isBsBonus}
        cardType={cardType}
      />
    </Box>
  );
};

export default CardContent;
